import React, { useMemo } from 'react'
import ReversingLabSpectraMappingForm from './ReversingLabSpectraMappingForm';
import ReversingLabSpectraCredentialsForm from './ReversingLabSpectraCredentialsForm';
import GenericPullConfigListing from '../GenericPullConfigListing';
import { columnRenderArrayData } from 'utils/tableUtils';
import { isEmpty } from 'lodash';

export default function ReversingLabSpectraConfigListing(props) {
    const columns = useMemo(() => [{
        title: "Group",
        dataIndex: "group",
        width: 200
    },
    {
        title: "Project",
        dataIndex: "project",
        width: 200
    },
    {
        title: "Package",
        dataIndex: "package",
        width: 200
    },
    {
        title: "Release",
        dataIndex: "release",
        width: 200,
        render: release => isEmpty(release) ? "All" : columnRenderArrayData(release)
    },
    ], [])
    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            extraColumns={columns}
            MappingForm={ReversingLabSpectraMappingForm}
            CredentialsForm={ReversingLabSpectraCredentialsForm}
        />
    )
};